import noop from 'utils/noop';
import { ENTER_KEY } from 'constants/keyCodes';
import { FolderCardProps } from './types';
import { FOLDER_HEIGHT } from './constants';
import {
  CardStyled,
  CardContentWrapper,
  FolderCardIcon,
  FolderCardText,
} from './FolderCard.styled';

export const FolderCard = ({
  Prefix,
  shouldHover = true,
  hasBoxShadow = true,
  onClick = noop,
  children,
  ...props
}: FolderCardProps) => {
  const handleOnKeyUp = (e: KeyboardEvent) => {
    if (e.keyCode === ENTER_KEY) {
      /**
       * leaving this in for now, but from what i can tell this doesn't do anything,
       * since, as the ts error points out, keyboard events don't have an e.target.click involved.
       * is this maybe supposed to be the `onClick` prop?
       */
      // @ts-expect-error
      e.target.click();
    }
  };

  return (
    <CardStyled
      data-test="FolderCard"
      shouldHover={shouldHover}
      hasBoxShadow={hasBoxShadow}
      onClick={onClick}
      tabIndex={0}
      onKeyUp={handleOnKeyUp}
      {...props}
    >
      <CardContentWrapper>
        {Prefix && Prefix}
        <FolderCardIcon
          data-test="FolderCard-Icon"
          height={FOLDER_HEIGHT / 2} // calculations based off a default height of 48px from figma
          width={FOLDER_HEIGHT / 2} // calculations based off a default height of 48px from figma
        />
        <FolderCardText $hasPrefix={!!Prefix} data-test="FolderCard-Text">
          {children}
        </FolderCardText>
      </CardContentWrapper>
    </CardStyled>
  );
};

export default FolderCard;
